export const KEYS = { THUNK_NAME: 'user/processUserInfo' };
